<template>
    <SoliAvatarBtn
        v-if="type && duration && (instrument || event)"
        @click="$emit('input', $event)"
        :title="lessonTitle"
        icon="music_note"
        :subtitleBottom="
            substitutePass ? 'Reschedule as private lesson' : null
        "
        :subtitleBottom2="duration + ' min'"
        blue
    >
    </SoliAvatarBtn>
</template>

<script>
export default {
    props: {
        type: {
            type: Object,
            default: null,
        },
        assessmentType: {
            type: Object,
            default: null,
        },
        instrument: {
            type: Object,
            default: null,
        },
        event: {
            type: Object,
            default: null,
        },
        duration: {
            type: [Number, String],
            default: null,
        },
        substitutePass: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        lessonTitle() {
            if (this.event) return this.event.title;
            if (this.assessmentType?.apl) return "Piano Lab";
            if (this.instrument) {
                return `${this.instrument.name} ${this.type.name}`;
            }
        },
    },
};
</script>

<style></style>
